function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	if (document.querySelector("#_upsert-score")) {
		const element = document.querySelector("#_upsert-score");
		fetch(`/misc/upsert_score/${element.dataset.ct}/${element.dataset.id}/`, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		}).catch((error) => {
			console.warn(error);
		});
	}
});
